import PropTypes from "prop-types";

import ServiceWrapper from "../utils/ServiceWrapper";

import {
    OE_ALL_ACTION_CONTROLS,
    OE_DISTRICT_WINDOWS_BY_SCHOOLYEAR,
    OE_PARTICIPATING_SCHOOL,
    OE_SCHOOL_YEAR_KEY,
    OE_STUDENT,
    OE_STUDENT_DETAILS,
    OE_STUDENT_SEARCH
} from "../const/OpenEnrollmentConst";

/**
 * Data Access for the Open Enrollment API
 * @name OpenEnrollmentDao
 * @param props
 * @return {null|*}
 */
const OpenEnrollmentDao = (props) => {
    const { action, key, params, schoolYearKey, token } = props;
    const bearer = `Bearer ${token}`;
    const options = {
        headers: {
            Authorization: bearer
        },
        withCredentials: true
    };
    switch (action) {
        case "allActionControlsRead":
            options.method = "GET";
            options.params = params;
            options.url = OE_ALL_ACTION_CONTROLS;
            break;
        case "allDistrictWindowsRead":
            options.method = "GET";
            options.url = `${OE_DISTRICT_WINDOWS_BY_SCHOOLYEAR}/${schoolYearKey}/index.json`;
            break;
        case "participatingSchoolRead":
            options.method = "GET";
            if (params) {
                options.params = params;
            }
            options.url = `${OE_PARTICIPATING_SCHOOL}/${key}/detail.json`;
            break;
        case "schoolYearRead":
            options.method = "GET";
            options.url = OE_SCHOOL_YEAR_KEY;
            break;
        case "studentDetailsRead":
            options.method = "GET";
            options.url = `${OE_STUDENT_DETAILS}/${key}/detail.json`;
            break;
        case "studentDetailsSearch":
            options.method = "GET";
            options.params = params;
            options.url = `${OE_STUDENT_SEARCH}/${schoolYearKey}/index.json`;
            break;
        case "studentsByParentGuidRead":
            options.method = "GET";
            options.params = params;
            options.url = `${OE_STUDENT}/${schoolYearKey}/index.json`;
            break;
        default:
            return null;
    }

    return ServiceWrapper.serviceCall({
        options,
        ...props
    });
};

OpenEnrollmentDao.propTypes = {
    action: PropTypes.string.isRequired,
    key: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    params: PropTypes.oneOfType([PropTypes.object]),
    schoolYearKey: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    token: PropTypes.string.isRequired,
    username: PropTypes.string
};

OpenEnrollmentDao.defaultProps = {
    key: null,
    params: null,
    schoolYearKey: null,
    username: null
};

export default OpenEnrollmentDao;
